import React, { useEffect, useState } from "react";
import "./style.scss";
import api from "../../api";

export default function SingleAd() {
  const [banner, setBanner] = useState(null);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await api.get("/add-banners");
        const advisements = res.data?.data?.Advisement || [];

        const filtered = advisements.filter(
          (ad) => ad.position === "Top Left" && ad.show === "1"
        );

        if (filtered.length > 0) {
          const sorted = [...filtered].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setBanner(sorted[0]);
          setImageFailed(false);
        } else {
          setBanner(null);
          setImageFailed(false);
        }
      } catch (err) {
        console.error("Failed to load banners:", err.response?.data || err.message);
        setBanner(null);
        setImageFailed(false);
      }
    };

    fetchBanner();
  }, []);

  const hasRenderableAd = Boolean(banner?.image_video) && !imageFailed;

  return (
    <div className="ad-card">
      {hasRenderableAd ? (
        <a href={banner?.url || "#"} target="_blank" rel="noopener noreferrer">
          <img
            src={banner.image_video}
            alt="Advertisement"
            className="ad-image img-fluid"
            onError={() => setImageFailed(true)}
          />
        </a>
      ) : (
        <div className="ad-image ad-image-empty" aria-hidden="true" />
      )}
    </div>
  );
}
